import { Button, Modal } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CrossInCircleIcon } from '@components/common/Icons/CrossInCircleIcon';
import { ConfirmDialogProps } from './types';
import { colors } from '@/variables';

export const ConfirmDialog: FC<ConfirmDialogProps> = ({ onClose, open, titleKey, onCancel, onConfirm }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      closable={false}
      centered
      width={'fit-content'}
      classNames={{
        content: 'relative rounded-[1.4rem]! p-[3rem_2rem]!',
        body: 'p-0!',
      }}
      styles={{
        content: { borderRadius: '1.4rem' },
      }}
    >
      <CrossInCircleIcon
        className={'absolute top-5 right-5 cursor-pointer'}
        color={colors.primary}
        onClick={handleClose}
      />

      <h3 className={'text-night-sky mb-6 text-center font-bold'}>
        <FormattedMessage id={titleKey} />
      </h3>

      <div className={'flex items-center justify-center gap-4'}>
        <Button type={'text'} danger className={'font-satoshi-medium h-auto! uppercase shadow-none'} onClick={onCancel}>
          <FormattedMessage id={'cta.cancel'} />
        </Button>
        <Button
          type={'text'}
          className={'font-satoshi-medium h-auto! uppercase text-brand! shadow-none'}
          onClick={onConfirm}
        >
          <FormattedMessage id={'cta.confirm'} />
        </Button>
      </div>
    </Modal>
  );
};
